module.exports = __webpack_public_path__ + "img/order-confirmation-picture-data.c13251d7.png";